import { AppState } from '@chegg-wt/core/state'
import { CitationsJWT } from '@chegg-wt/core/types/auth'
import { parseJwt } from '@chegg-wt/core/utils/jwt'
import { createSelector } from 'reselect'
import { UserRoles } from '@chegg-wt/core/constants/user'
import { trackWithoutThrow } from '@chegg-wt/core/utils/errors'

export const userSelector = (state: AppState) => state.user.user

export const userEmailSelector = (state: AppState) =>
  state.user && state.user.user && state.user.user.email

export const userRoleSelector = (state: AppState) =>
  state.user && state.user.user && state.user.user.role

export const isAuthLoadingSelector = (state: AppState) =>
  state.user && state.user.isLoading

export const userProjectIdSelector = (state: AppState) =>
  state.user && state.user.projectId

export const isProSelector = createSelector(
  [userRoleSelector],
  (role): boolean => role === UserRoles.PRO_USER
)

export const isGuestSelector = createSelector(
  [userRoleSelector],
  (role): boolean => role === UserRoles.NOT_LOGGED_IN
)

export const isUserEduSelector = createSelector([userRoleSelector], (role: string) => {
  const EDU_ROLES = ['edu', 'edu_admin', 'edu_coppa']
  return EDU_ROLES.includes(role)
})

export const dataMigrationIsInProgressSelector = (state: AppState) =>
  state.user.dataMigrationInProgress

export const migrationIdSelector = (state: AppState) => state.user.migration_id

export const migrationStatusSelector = (state: AppState) => state.user.status

export const jwtSelector = (state: AppState) => {
  if (!state?.user?.jwt) return null

  try {
    return parseJwt(state.user.jwt)
  } catch (e) {
    trackWithoutThrow(e)
    return null
  }
}

export const loggedInSelector = createSelector(
  [jwtSelector],
  (jwt: CitationsJWT | null): boolean => !!jwt?.email
)

export const idTokenSelector = createSelector(
  [jwtSelector],
  (jwt: CitationsJWT | null): string | null => jwt?.cheggTokens?.id_token || null
)

export const accessTokenSelector = createSelector(
  [jwtSelector],
  (jwt: CitationsJWT | null): string | null => jwt?.cheggTokens?.access_token || null
)

export const softLoggedInSelector = createSelector(
  [idTokenSelector, accessTokenSelector],
  (idToken: string | null, accessToken: string | null): boolean =>
    !!idToken && !accessToken
)

export const getSelectedUserTypeSelector = (state: AppState) =>
  state.user.selectedUserType

export const getSelectedSchoolTypeSelector = (state: AppState) =>
  state.user.selectedSchoolType

export const hasPaperSelector = (state: AppState) => state.user.hasPaper
